module.exports = {
  withdrawn: 'MEDICATIONS.V2.FORM.OPTION.ACTION_TAKEN.WITHDRAWN',
  dose_reduced: 'MEDICATIONS.V2.FORM.OPTION.ACTION_TAKEN.DOSE_REDUCED',
  dose_increased: 'MEDICATIONS.V2.FORM.OPTION.ACTION_TAKEN.DOSE_INCREASED',
  dose_not_changed: 'MEDICATIONS.V2.FORM.OPTION.ACTION_TAKEN.DOSE_NOT_CHANGED',
  unknown: 'MEDICATIONS.V2.FORM.OPTION.ACTION_TAKEN.UNKNOWN',
  na: 'MEDICATIONS.V2.FORM.OPTION.ACTION_TAKEN.NA',
};
